import { useHistory } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../../../../../api";
import { AxiosError } from "axios";
import { AttendanceLocalDepartmentQueueServiceTimeComplementException } from "../../../../../../../../@types/attendance-local-department-queue-service-time-complement-exception";
import { AttendanceLocalDepartment } from "../../../../../../../../@types/attendance-local-department";

export type AttendanceLocalDepartmentQueueServiceTimeComplementExceptionCreateData = Pick<
    AttendanceLocalDepartmentQueueServiceTimeComplementException,
    | "fila"
    | "data"
    | "tempo"
    | "horario_especial"
    | "hora_inicio"
    | "hora_fim"
    | "intervalo_hora_inicio"
    | "intervalo_hora_fim"
> & {
    setor: AttendanceLocalDepartment["id"];
    servico: AttendanceLocalDepartmentQueueServiceTimeComplementException["servico"]["id"];
}

export function useAttendanceLocalDepartmentQueueServiceTimeComplementExceptionCreate() {
    const history = useHistory();
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation({
        mutationKey: ["attendance-local", "department", "queue", "service-time-complement-exception", "create"],
        mutationFn: async (data: AttendanceLocalDepartmentQueueServiceTimeComplementExceptionCreateData) => {
            const response = await apisiseci.post<AttendanceLocalDepartmentQueueServiceTimeComplementException>(
                '/cms/excecao_horario_agendamento_complementar/', data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ['attendance-local', 'department', 'queue', 'service-time-complement-exception', 'list']
            });
            toast.success("Exceção de tempo de serviço complementar criado com sucesso!");
            history.replace({
                pathname: history.location.pathname.replace(/\/novo$/, ""),
                state: { showSuccessAlert: true }
            });
        },
        onError: (error: AxiosError<{ detail: string }>) => {
            toast.error(
                error?.response?.data?.detail || "Algo deu errado, tente novamente!"
            );
            console.log(error);
        },
    });

    return mutation;
}
